'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIllustration from 'UIComponents/image/UIIllustration';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { NavMarker } from 'react-rhumb';
import { SCREENS } from '../constants/Tracking';

function ErrorPage() {
  useEffect(() => {
    getUsageTracker().track('pageView', {
      screen: SCREENS.ERROR
    });
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: "flex-column align-center p-all-10",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "ERROR_PAGE"
    }), /*#__PURE__*/_jsx(UIIllustration, {
      className: "m-y-10",
      name: "errors/general",
      height: 200
    }), /*#__PURE__*/_jsx("h4", {
      className: "m-top-6",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "errorPage.title"
      })
    }), /*#__PURE__*/_jsx("p", {
      className: "m-bottom-10",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "errorPage.paragraph"
      })
    })]
  });
}

export default ErrorPage;